import React, { ReactElement, useContext } from 'react';
import Styled from './NavDivider.styled';
import { ComponentProps } from './NavDivider.types';
import Context from '../Context';

const NavDivider: React.FC<ComponentProps> = ({ children, ...props }): ReactElement<ComponentProps> => {
  const ctx = useContext(Context);

  return (
    <Styled variant={ctx.variant} {...props}>
      <svg width="1" height="24" viewBox="0 0 1 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="0.999998" height="24" transform="matrix(1 0 1.37429e-08 -1 0 24)" />
      </svg>
    </Styled>
  );
};

export default NavDivider;
